import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { EmailProvider } from './contexts/EmailContext'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { useEffect } from 'react'
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import theme from './theme'
import Home from './pages/Home'
import About from './pages/About'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import './App.css'
import { initGA, trackPageView } from './utils/analytics'

// Component to track route changes
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

// TODO: Actually make this a nonce. Need enterprise plan for this..
const nonce = "6JrfaraV8iqcS";
const emotionCache = createCache({ key: 'css', nonce });

function App() {
  // Initialize Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <EmailProvider>
          <Router>
            <RouteTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />  {/* Add the new route */}
              <Route path="/terms" element={<Terms />} />
              {/* Add more routes as needed */}
              {/* <Route path="/contact" element={<Contact />} /> */}
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
          </Router>
        </EmailProvider>
      </ThemeProvider>
    </CacheProvider>
  )
}

export default App
